// 全局挂载 axios（推荐方式）
import axios from 'axios'
import {showFullScreenLoading, tryHideFullScreenLoading} from './loading'

//部署修改后台路径
const baseURL = 'https://crm.deecoo.com:443/kjfwgl/';
const baseURL1 = 'http://localhost:8222';
const baseURL123 = 'http://192.168.1.10:8222';

const instance = axios.create({
    baseURL,
    timeout: 50000,
});

instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        showFullScreenLoading()
        // 如果存在 data 属性，则将其视为 JSON 数据
        if (config.data) {
            if (isfilepath(config.url)) {
                config.headers['Content-Type'] = 'multipart/form-data';
            } else {
                config.headers['Content-Type'] = 'application/json';
            }

        }
        return config;
    },
    (error) => {
        tryHideFullScreenLoading()
        return Promise.reject(error);
    }
);

function isfilepath(url) {
    //文件上传白名单
    let filepathList = ['/basic/upOrder','/basic/upProPic','/basic/upProCpsc']
    if (filepathList.includes(url)) {
        return true;
    } else {
        return false;
    }
}

instance.interceptors.response.use(
    (response) => {
        // 成功响应：关闭遮罩，返回 data
        tryHideFullScreenLoading()
        return response.data
    },
    (error) => {
        // 失败响应：先关闭遮罩
        tryHideFullScreenLoading()

        // 判断是否是 token 过期/未授权（401 或 403）
        if (error.response && [401, 403].includes(error.response.status)) {
            // 防止重复跳转（死循环保护）
            if (!error.config._retry) {
                error.config._retry = true

                // 清空登录状态
                localStorage.removeItem('isLoggedIn')
                localStorage.removeItem('token')
                localStorage.removeItem('username')

                // 获取当前页面路径，用于登录后跳回
                const currentPath = encodeURIComponent(window.location.pathname + window.location.search)

                // 跳转登录页，带 redirect 参数
                window.location.href = `/#/login?redirect=${currentPath}`

                // 如果你在 Vue 组件内，也可以用 router（但拦截器里推荐用 location.href）
                // this.$router.push({ path: '/login', query: { redirect: currentPath } })
            }
        }

        // 统一错误提示（可选，根据你的项目风格）
        let msg = '请求失败，请稍后重试'
        if (error.response) {
            // 后端返回了响应，但状态码非 2xx
            msg = error.response.data?.message || error.response.data?.msg || `请求错误 (${error.response.status})`
        } else if (error.request) {
            // 没收到响应（网络问题）
            msg = '网络连接失败，请检查网络或服务器是否启动'
        } else {
            msg = error.message || '未知错误'
        }

        // 如果你有全局 Message（如 Element UI）
        if (typeof this !== 'undefined' && this.$message) {
            this.$message.error(msg)
        } else {
            console.error(msg) // 兜底
        }

        // 继续抛出错误，让调用方处理
        return Promise.reject(error)
    }
)

const request = {
    getHttp: ({url, params, success, error}) => {
        instance.get(url, {params})
            .then((response) => {
                success(response);
            })
            .catch((err) => {
                error(err);
            });
    },

    postHttp: ({url, data, params, success, error}) => {
        // 如果同时存在 data 和 params，则使用 data 发送 JSON 数据
        if (data && !params) {
            instance.post(url, data)
                .then((response) => {
                    success(response);
                })
                .catch((err) => {
                    error(err);
                });
        } else {
            instance.post(url, null, {params})
                .then((response) => {
                    success(response);
                })
                .catch((err) => {
                    error(err);
                });
        }
    },

    // 添加其他接口方法...
};
export default request;
